import React from 'react';

export const PalettePageGradient = ({ palette }) => (
  <div style={{
    position: 'fixed',
    inset: 0,
    zIndex: 0,
    pointerEvents: 'none',
    background: `
      radial-gradient(ellipse 85% 65% at 15% 0%, ${palette.color}26 0%, transparent 62%),
      radial-gradient(ellipse 65% 55% at 85% 100%, ${palette.color}17 0%, transparent 58%),
      radial-gradient(ellipse 100% 80% at 50% 100%, rgba(0,0,0,0.45) 0%, transparent 60%)
    `,
  }} />
);
